import { requestJson } from "./instateamAdminApi";

export function getAdminLeavesOverview(token, params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value) !== "") {
      searchParams.set(key, value);
    }
  });

  return requestJson(`/instateam/leaves/admin/overview?${searchParams.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function createAdminLeaveRequest(token, payload) {
  return requestJson("/instateam/leaves/admin/request", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function reviewAdminLeaveRequest(token, leaveId, payload) {
  return requestJson(`/instateam/leaves/admin/${leaveId}/review`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function importAdminLeaves(token, rows) {
  return requestJson("/instateam/leaves/admin/import", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows }),
  });
}
